import { usePostPortfolioLeasingMutation } from "web_myplann/Api/Portfolio/Mutations/usePostPortfolioLeasingMutation";
import { LeasingProductCategoryKeyEnum } from "web_myplann/Infrastructure/Api/Api";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { LEASING_FORM_DEFAULT_VALUES } from "web_myplann/Portfolio/Forms/LeasingForm/leasingFormDefaults";
import { getLeasingFormSchema } from "web_myplann/Portfolio/Forms/LeasingForm/leasingFormSchema";
import { useCreatePortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useCreatePortfolioForm";

export const useCreateLeasingForm = () => {
	const { t } = useResource();
	const { mutate, isPending } = usePostPortfolioLeasingMutation();

	const { form, onSubmit } = useCreatePortfolioForm({
		schema: getLeasingFormSchema(t),
		defaultValues: LEASING_FORM_DEFAULT_VALUES,
		mutate: (portfolioFields, options) =>
			mutate(
				{
					...portfolioFields,
					productCategory: LeasingProductCategoryKeyEnum.Leasing,
				},
				options,
			),
		successRoute: Routing.Portfolio.PortfolioAddLeasingSuccess.path(),
	});

	return { form, onSubmit, isPending };
};
